/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { DailyNavRecordBreakdown } from './DailyNavRecordBreakdown';
import type { DailyNavRecordConfig } from './DailyNavRecordConfig';
import type { DailyNavRecordSecondaryBreakdown } from './DailyNavRecordSecondaryBreakdown';
export type DailyNavRecord = {
  readonly id?: number;
  firm: number;
  company: number;
  date: string;
  status?: DailyNavRecord.status | null;
  reviewed_by_scalar?: boolean;
  discussed_with_fund?: boolean;
  price_adjusted?: boolean;
  review_notes?: string | null;
  measurement_date?: number | null;
  readonly cap_iq_delta_exceeded?: boolean;
  breakdown?: DailyNavRecordBreakdown;
  readonly secondary_delta_exceeded?: boolean;
  secondary_breakdown?: DailyNavRecordSecondaryBreakdown;
  config?: DailyNavRecordConfig;
  readonly created_at?: string;
  readonly updated_at?: string;
};
export namespace DailyNavRecord {
  export enum status {
    IN_PROGRESS = 'in_progress',
    REVIEWED = 'reviewed',
    RECOMMENDED = 'recommended',
    NOT_RECOMMENDED = 'not_recommended',
  }
}

